// Copyright (c) StrangeBee 2023

import { TitleSection } from '@Atoms/TitleSection/TitleSection';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THForm } from '@Molecules/THForm/THForm';
import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';
import { TemplateHelpType } from '@Molecules/Inputs/THTextArea/Helper';
import { useLocalMessage } from '@Helpers/locale';

interface HeadersFormItemsProps {
    onChange?: () => void;
    notifierName?: string;
    extraFields?: TemplateHelpType[];
}

export const HeadersFormItems = ({ onChange, notifierName, extraFields }: HeadersFormItemsProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <THForm.List name="headers">
            {(fields, { add, remove }) => (
                <>
                    <TitleSection
                        className="notifier-manage__title-section"
                        extraAction={<THButton icon={<ICONS.PlusIcon />} onClick={() => add()} />}
                    >
                        Headers
                    </TitleSection>

                    {fields.map(({ key, name }) => (
                        <div className="notifier-manage__headers" key={key}>
                            <THForm.Item
                                name={[name, 'key']}
                                fieldKey={[key, 'key']}
                                key={key}
                                label={i('endpoint.form.connector.http.headers.key.label')}
                                className="notifier-manage__headers__key"
                            >
                                <THInput placeholder={i('endpoint.form.connector.http.headers.key.placeholder')} />
                            </THForm.Item>

                            {onChange && notifierName ? (
                                <THInput.Helper
                                    extraFields={extraFields}
                                    name={[name, 'value']}
                                    completeItemName={['headers', name, 'value']}
                                    fieldKey={[key, 'value']}
                                    label={i('endpoint.form.connector.http.headers.value.label')}
                                    className="notifier-manage__headers__value"
                                    placeholder={i('endpoint.form.connector.http.headers.value.placeholder')}
                                    onChange={onChange}
                                />
                            ) : (
                                <THForm.Item
                                    name={[name, 'value']}
                                    fieldKey={[key, 'value']}
                                    label={i('endpoint.form.connector.http.headers.value.label')}
                                    className="notifier-manage__headers__value"
                                >
                                    <THInput
                                        placeholder={i('endpoint.form.connector.http.headers.value.placeholder')}
                                    />
                                </THForm.Item>
                            )}

                            <THButton
                                type="link"
                                onClick={() => remove(name)}
                                color="red"
                                className="notifier-manage__headers__delete"
                            >
                                {/* Delete */}
                                {i('endpoint.form.connector.http.headers.actions.delete')}
                            </THButton>
                        </div>
                    ))}
                </>
            )}
        </THForm.List>
    );
};
